import geoDataInstance from '../instance'

const fetchGeoDataPositions = () => {
	return geoDataInstance.get('/users/positions')
}

export default fetchGeoDataPositions
